
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/circular-to-manfred",
      function () {
        return require("private-next-pages/circular-to-manfred.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/circular-to-manfred"])
      });
    }
  